import { useQueries } from '@tanstack/react-query';
import type { OrgSummary } from '@aiai/shared';
import { fetchWorkspaceEntitlements } from '../api';
import { fuelOf, type Fuel } from './fuel';

export interface WorkspaceFuel {
  workspace: OrgSummary;
  fuel: Fuel;
}

/**
 * Each workspace's monthly budget as a fuel tank. One entitlements query per
 * workspace (the route's :orgId wins over the active-org header); workspaces
 * whose entitlements errored or are still loading are left out.
 */
export function useWorkspaceFuel(workspaces: OrgSummary[]): WorkspaceFuel[] {
  const results = useQueries({
    queries: workspaces.map((ws) => ({
      queryKey: ['workspaceEntitlements', ws.id],
      queryFn: () => fetchWorkspaceEntitlements(ws.id),
      refetchInterval: 60_000,
      retry: false,
    })),
  });
  const out: WorkspaceFuel[] = [];
  results.forEach((r, i) => {
    if (r.data) out.push({ workspace: workspaces[i], fuel: fuelOf(r.data) });
  });
  return out;
}
